// @core/api/endpoints/project/delete_component.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/project';

/**
 * Delete component
 * Deletes a component. Items assigned to this component are unlinked but remain in the project.
 */
export async function DeleteComponent(
  project_id: string,
  component_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/components/:component_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':component_id', encodeURIComponent(component_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
